
let styles = {
    container: {
      padding: '3%',
      display: 'flex',
      justifyContent: 'center',
      flexDirection:'column'
    },
  
    table: {
      backgroundColor: '#dcdcdc',
      padding: '1%',
    },
  
    items: {
      padding: '1%',
    },
  
    item_header: {
      fontSize: '120%',
      fontWeight: 600,
      paddingLeft: '10%',
    },
  
    item_body: {
      padding: '6px ',
    },
  
    main_header: {
      padding: '1%',
      marginBottom: '3%',
      backgroundColor: '#32B6A7',
    },
  
    button_submit: {
      padding: '1%',
      justifyContent: 'center',
      display: 'flex',
      paddingTop: '6%',
    },
  
    input: {
      width: '50%',
    },
  
    success: {
      textAlign: 'center',
      fontSize: '120%',
      fontWeight: 800,
    },

    card_contents: {
        fontSize: '16px',
        textAlign: 'center',
      },
      card: {
        border:'1px solid grey',
        backgroundColor:'white',
      },
      card_header: {
        paddingLeft: '1.5%',
        color: '#32B6A7',
        fontSize: '130%',
      },
      card_rows : {
        paddingLeft:'1.5%',
      },
      booking : {
        padding: '1%',
        marginBottom:'1%',
        color: '#32B6A7',
        fontSize: '130%',
        borderBottom: '1px dashed',
      },
      icons : {
        display: 'flex',
        justifyContent: 'center',
      },
  }
  export default styles
  


// WEBPACK FOOTER //
// ./src/app/views/partner/crud/CriticalTimeSlot/style.js